module.exports = "/static/images/favicon.png";